import { createI18n } from 'vue-i18n';
const localeLoaders = import.meta.glob('./lang/*.json');
const domesticLanguages = ['zh_CN', 'en_US'];
const overseasLanguages = ['en_gaia', 'ja_JP'];
const supportedLanguages = overseasLanguages;
const storedLanguage = localStorage.getItem('language');
const defaultLang = supportedLanguages.includes(storedLanguage)
  ? storedLanguage
  : 'en_gaia';
const htmlLangMap = {
  zh_CN: 'zh-CN',
  en_US: 'en',
  en_gaia: 'en',
  ja_JP: 'ja'
};
if (typeof document !== 'undefined') {
  document.documentElement.setAttribute(
    'lang',
    htmlLangMap[defaultLang] || defaultLang.replace('_', '-')
  );
}
const loadLocaleMessages = async locale => {
  const loader = localeLoaders[`./lang/${locale}.json`];
  if (!loader) {
    throw new Error(`Unsupported locale: ${locale}`);
  }
  const module = await loader();
  return module.default;
};
const messages = {
  [defaultLang]: await loadLocaleMessages(defaultLang)
};
const i18n = createI18n({
  legacy: false,
  locale: defaultLang,
  globalInjection: true,
  keystyle: 'nested',
  messages
});
export const langList = [
  {
    label: 'English',
    value: 'en_gaia'
  },
  {
    label: '日本語',
    value: 'ja_JP'
  }
];
export default i18n;
